const TOAST_POSITION = {
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_RIGHT: 'bottom right',
  TOP_LEFT: 'top left',
  TOP_RIGHT: 'top right'
};

const TOAST_TYPE = {
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning'
};

export { TOAST_POSITION, TOAST_TYPE };
